export default __webpack_public_path__ + "static/media/RadioButtonSelected.8c7f54aa.svg";